<template>
    <div class="cal__footer">
        <div class="cal__footer_info" v-if="this.$store.state.device === 'desktop'">
            <span class="cal__footer_i">i</span><br>
            <span class="cal__footer_info_title">Plus d'infos</span>
        </div>
        <div class="cal__footer_content">
            <div class="cal__footer_header">
                <span class="cal__footer_i cal--is-tablet">i</span>
                <span class="cal__footer_title" v-if="job === null">Mode d'emploi</span>
                <span class="cal__footer_title" v-else>{{ job.titre }}</span>
                <span class="cal__footer_tjm" v-if="job !== null">
                    TJM : {{ formatNumber(job.tjm_ht) }} / jour</span>
            </div>
            <div class="cal__footer_description" v-if="job === null">
                Saisissez une estimation du nombre de jours homme que vous pensez
                allouer pour chaque profil
            </div>
            <div class="cal__footer_description" v-else v-html="formatProfil(job.experience, job.profil)">
            </div>
        </div>
        <div class="cal__excel" id="cal__excel">
            <div class="cal__excel_icone_wrapper" id="cal__excel_icone_wrapper" v-on:click="toggleFooter">
              <div class="cal__excel_icone_container">
                <img src="../assets/img/microsoft-excel.svg" class="cal__excel_icone_img" />  
                <div class="cal__excel_icone_cross" />  
              </div>
            </div>
            <div class="cal__excel_icone_wrapper_bottom"></div>
            <transition name="fade">
                <div class="cal__excel_content_wrapper" v-if="type === 'form'">
                    <div class="cal__excel_icone">
                        <img src="../assets/img/excel-content-icone.jpg" />
                    </div>
                    <div class="cal__excel_content">
                      <div class="cal__excel_title cal__font_bree">
                        Recevez le fichier source Excel (avec TJM modifiables) <br class="cal--is-desktop">de cette simulation.
                        <br class="cal--is-tablet">Idéal pour vos présentations !
                      </div>
                      <div class="cal__excel_mentions">
                        *Inscription conforme <a href="https://www.eficiens.com/privacy/" target="_blank">RGPD Eficiens</a>.
                        Aucune exploitation de votre email.
                      </div>
                    </div>
                    <div class="cal__excel_input_container">
                      <form v-on:submit="checkForm">
                        <input 
                            type="text"
                            class="cal__excel_input"
                            :class="{ 'cal__excel_input--error': this.error === true}"
                            placeholder="Votre email*"
                            v-bind:email="email"
                            v-on:input="updateEmail"
                            v-on:focus="updateFocus"
                            v-bind:value="email" >
                        <input class="cal__excel_submit" type="submit" value="ok" >
                      </form>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div class="cal__thanks_wrapper" v-if="type === 'merci'">
                    <div class="cal__thanks_icone_left">
                        <img src="../assets/img/bonhomme-2.svg" />
                    </div>
                    <div class="cal__thanks_content cal__font_bree">
                      Merci. Vous allez recevoir prochainement les fichiers demandés.
                      <br>Si vous souhaitez nous contacter : contact@eficiens.com
                    </div>
                    <div class="cal__thanks_icone_right">
                      <img src="../assets/img/soon.jpg" />
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>


<script>

import { formatNumber, formatProfil } from "../utils/index";

export default {
  name: 'AppFooter',
  props: {
    job: Object
  },
  data: function(){
    return {
      type: 'form', // form, merci
      email: '',
      error: false,
      emailRegex: /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }
  },
  methods: {
    formatNumber: function(nb) {
      return formatNumber(nb)
    },
    formatProfil: function(experience, profil) {
      return formatProfil(experience, profil)
    },
    toggleFooter: function(){
        if (this.$store.getters.footerIsOpen) {
          document.getElementById('cal__excel').className = 'cal__excel cal__excel--close'
          this.$store.commit('UNFREEZE_APP')
          if (this.type === 'merci') {
            this.type = 'form'
          }
        } else {
          document.getElementById('cal__excel').className = 'cal__excel cal__excel--open'
          this.$store.commit('FREEZE_APP')
        }
        this.$store.commit('UPDATE_FOOTER_POSITION')
    },
    checkForm: function (e) {
      e.preventDefault();
      if (!this.emailRegex.test(this.email)) {
        this.error = true
      } else {
        this.error = false
        this.$store.commit('UPDATE_EMAIL', { email: this.email })
        this.$store.dispatch('sendData');
        this.type = 'merci'
      }      
    },
    updateEmail: function(e) {
      this.email = e.target.value
    },
    updateFocus: function() {
      this.error = false
    }
  }
}
</script>

